
import React from 'react';
import { Flower2 } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="w-full bg-sage-50 border-t-4 border-rose-100/60 pt-12 pb-10 mt-20 relative overflow-hidden">
      
      {/* Decorative Pink Bloom - Subtle background accent */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-rose-50/60 rounded-full blur-3xl pointer-events-none -translate-y-1/2 translate-x-1/3"></div>

      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-8 md:gap-4 relative z-10">
        
        {/* Left: Brand Identity - Fix centering in all modes */}
        <div className="flex flex-col items-center md:items-center text-center min-w-[200px] w-full md:w-auto">
          <span className="font-serif text-lg font-bold text-stone-700 tracking-widest leading-relaxed">言屿心理咨询室</span>
          <span className="text-[10px] uppercase tracking-[0.1em] text-sage-500 mt-1 font-medium">
            YANYU PSYCHOLOGICAL COUNSELING STUDIO
          </span>
        </div>

        {/* Center: Quote with Pink Accent */}
        <div className="flex flex-col items-center justify-center flex-1 mx-4 group hidden md:flex">
           <div className="flex items-center gap-3">
              <div className="w-6 h-[1px] bg-stone-300/50 group-hover:bg-rose-300 transition-colors duration-500"></div>
              <Flower2 size={14} className="text-rose-300 animate-[spin_10s_linear_infinite] opacity-80" />
              <div className="w-6 h-[1px] bg-stone-300/50 group-hover:bg-rose-300 transition-colors duration-500"></div>
           </div>
           <p className="font-serif italic text-stone-600/90 text-sm mt-3 text-center leading-relaxed">
             "愿你在每一个此时此刻，都能拥有安放身心的角落。"
           </p>
        </div>

        {/* Right: Copyright & Links */}
        <div className="flex flex-col items-center md:items-end text-center md:text-right min-w-[200px] gap-2">
          <p className="text-xs text-stone-400 font-mono">© 2024 All rights reserved.</p>
          <div className="flex gap-4 text-xs text-stone-400/80">
             <span className="hover:text-rose-400 cursor-pointer transition-colors border-b border-transparent hover:border-rose-200">隐私政策</span>
             <span className="hover:text-rose-400 cursor-pointer transition-colors border-b border-transparent hover:border-rose-200">服务条款</span>
          </div>
        </div>

      </div>
    </footer>
  );
};
